import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { API_PATHS, errorMessages } from "../../Utils/Constants/constants";
import { postData } from "../../Utils/AxiosRequest";
import { checkNameSpecialCharacters, phoneValidate } from "../../Utils/validation/validators";
import { Spinner } from "react-bootstrap";

const ContactUsForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [response, setResponse] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    reset
  } = useForm();

  const onSubmit = async (data) => {
    setSubmitted(true);
    setIsSubmitting(true);
    const reqBody = { ...data };
    try {
      const response = await postData(API_PATHS.addQuery, reqBody);

      if (response.status === 200 && response.data.IsSuccess) {
        setResponse('Message sent successfully');
        reset();
      } else {
        setResponse(errorMessages.error);
      }
    } catch (error) {
      console.error(error);
      setResponse(errorMessages.error);
    }
    setTimeout(() => {
      setResponse('');
      setSubmitted(false);
    }, 3000);
    setIsSubmitting(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-sm-12">
          <div className="form-group">
            <input
              type="text"
              className={`form-control ${errors.Fullname && isDirty
                ? "red-placeholder border border-danger"
                : ""
                }`}
              placeholder={
                errors.Fullname && isDirty
                  ? errors.Fullname.message
                  : "Name"
              }
              autoComplete="off"
              {...register("Fullname", {
                required: "Please enter your Name",
                validate: (v) =>
                  checkNameSpecialCharacters(v, "Name"),
              })}
              disabled={isSubmitting}
            />
          </div>
        </div>
        <div className="col-sm-12">
          <div className="form-group">
            <input
              type="email"
              className={`form-control ${errors.EmailAddress && isDirty
                ? "red-placeholder border border-danger"
                : ""
                }`}
              placeholder={
                errors.EmailAddress && isDirty
                  ? errors.EmailAddress.message
                  : "Email"
              }
              autoComplete="off"
              {...register("EmailAddress", {
                required: "Please enter your Email",
              })}
              disabled={isSubmitting}
            />
          </div>
        </div>
        <div className="col-sm-12">
          <div className="form-group">
            <input
              type="text"
              className={`form-control ${errors.ContactNo && isDirty
                ? "red-placeholder border border-danger"
                : ""
                }`}
              placeholder={
                errors.ContactNo && isDirty
                  ? errors.ContactNo.message
                  : "Phone Number"
              }
              {...register("ContactNo", {
                required: "Please enter your Phone Number",
                maxLength: {
                  value: 10,
                  message: "Please enter a valid mobile number",
                },
                minLength: {
                  value: 10,
                  message: "Please enter a valid mobile number",
                },
                validate: phoneValidate,
              })}
              disabled={isSubmitting}
            />
          </div>
        </div>
        <div className="col-sm-12">
          <div className="form-group">
            <textarea
              type="text"
              rows='10'
              className={`form-control ${errors.UserMessage && isDirty
                ? "red-placeholder border border-danger"
                : ""
                }`}
              placeholder={
                errors.UserMessage && isDirty
                  ? errors.UserMessage.message
                  : "Message"
              }
              autoComplete="off"
              {...register("UserMessage", {
                required: "Please add a Message",
              })}
              disabled={isSubmitting}
            />
          </div>
        </div>
        <div className="col-sm-12 ml-2">
          {(!isSubmitting && submitted) && <p>{response}</p>}
        </div>
        <div className="col-sm-12">
          <div className="form-group">
            {isSubmitting ? (
              <button
                className="btn green-btn px-5 cursor-na"
                disabled
              >
                <Spinner size="sm" />
              </button>
            ) : (
              <input
                type="submit"
                className="btn green-btn"
                value="Submit"
                disabled={submitted}
              />
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default ContactUsForm;
